/**
 * @desc 取消包裹
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.packageCancel.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/packageCancel`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
